import type { ColleagueListItem } from '@wundo/shared/colleagues.ts';
import type { MeetingFollowExceptionItem } from '@wundo/shared/meetingFollow.ts';

/**
 * The standing "always follow" correction for this colleague's one-to-ones,
 * matched on the address it stands on — under any of the addresses this
 * colleague meets under.
 */
export function followCorrectionFor(
  colleague: Pick<ColleagueListItem, 'emails'>,
  corrections: readonly MeetingFollowExceptionItem[],
): MeetingFollowExceptionItem | undefined {
  return followCorrectionsFor(colleague, corrections)[0];
}

/*
 * Every one of them: two addresses of one person can each sit in a followed
 * thread, and any one left behind keeps the person followed.
 */
export function followCorrectionsFor(
  colleague: Pick<ColleagueListItem, 'emails'>,
  corrections: readonly MeetingFollowExceptionItem[],
): MeetingFollowExceptionItem[] {
  const addresses = new Set(colleague.emails.map((email) => email.toLowerCase()));

  return corrections.filter(
    (correction) =>
      correction.target_kind === 'person' &&
      correction.follow === true &&
      correction.person_email !== null &&
      addresses.has(correction.person_email.toLowerCase()),
  );
}
